import React from "react";
import { personalFields } from "../form-data/interviewForm-data";
import { DatePicker } from "antd";
import RadioCheckboxInput from "../common-components/RadioCheckboxInput";
import { ChildFormProps, PersonalDetailProps } from "../../../types/Form-types";
import dayjs from "dayjs";
import { InterviewAssessmentTypes } from "../InterviewAssessmentForm";
import ErrorMessage from "../common-components/ErrorMessage";

const maritalOptions = [
  { key: "Single", label: "Single" },
  { key: "Married", label: "Married" },
  { key: "Divorced", label: "Divorced" },
  { key: "Widowed", label: "Widowed" },
];

interface PersonalDetailsComponentProps extends ChildFormProps {
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleDateChange: (name: string, value: string) => void;
  handleFieldChange: (name: string, value: string) => void;
}

const PersonalDetails = ({
  formData,
  errors,
  handleChange,
  handleDateChange,
  handleFieldChange,
}: PersonalDetailsComponentProps) => {
  return (
    <>
      <p className="form-section-title text-center mb-3">Personal Details</p>

      <div className="table-responsive mb-4">
        <table className="form-table">
          <tbody>
            {/* Candidate Name */}
            <tr>
              <td className="td-label">
                Candidate Name: <span className="text-danger">*</span>
              </td>
              <td>
                <input
                  name="candidateName"
                  type="text"
                  value={formData?.candidateName || ""}
                  onChange={handleChange}
                />
                {errors?.candidateName && (
                  <ErrorMessage message={errors?.candidateName} />
                )}
              </td>
            </tr>

            {/* Gender */}
            <tr>
              <td className="td-label">
                Gender: <span className="text-danger">*</span>
              </td>
              <td className="d-flex flex-column gap-2">
                <div className="d-flex gap-4">
                  {["Male", "Female"].map((gen) => (
                    <RadioCheckboxInput
                      key={gen}
                      id={gen}
                      name="gender"
                      value={gen}
                      label={gen}
                      checked={formData?.gender === gen}
                      onChange={(e) =>
                        handleFieldChange(e.target.name, e.target.value)
                      }
                    />
                  ))}
                </div>
                {errors?.gender && <ErrorMessage message={errors?.gender} />}
              </td>
            </tr>

            {/* Dynamic Fields */}
            {personalFields?.map((f) => (
              <tr key={f.key}>
                <td className="td-label">
                  {f.label} <span className="text-danger">*</span>
                </td>
                <td className="">
                  {f.type === "date" ? (
                    <div className="d-flex align-items-center ">
                      <DatePicker
                        name={f.key}
                        style={{
                          width: "200px",
                          // marginTop: "-0.5rem",
                        }}
                        className="form-control d-inline datetimepicker inline col-4 ms-2"
                        format={{
                          format: "DD-MM-YYYY",
                          type: "mask",
                        }}
                        placeholder="DD-MM-YYYY"
                        value={
                          formData[f.key]
                            ? dayjs(formData[f.key] as string, "YYYY-MM-DD")
                            : ""
                        }
                        disabledDate={(current) =>
                          current && current.isAfter(dayjs(), "date")
                        }
                        onChange={(
                          date: any,
                          dateString: string | string[],
                        ) => {
                          if (!date) return;
                          const formatted =
                            typeof dateString === "string"
                              ? dateString
                              : dateString[0];
                          handleDateChange(f?.key, formatted);
                        }}
                      />
                      <ErrorMessage
                        message={errors?.[f.key]}
                        classStyle="ms-2"
                      />
                    </div>
                  ) : (
                    <>
                      <input
                        name={f.key}
                        // type={f.type}
                        type="text"
                        value={
                          String(
                            formData?.[f.key as keyof InterviewAssessmentTypes],
                          ) || ""
                        }
                        // onChange={handleChange}
                        className="form-control"
                        inputMode={
                          f.subType === "indian_number" ? "numeric" : undefined
                        }
                        onChange={(e) => {
                          if (f.subType === "indian_number") {
                            const val = e.target.value
                              .replace(/\D/g, "")
                              .slice(0, 10);
                            handleChange({
                              ...e,
                              target: { ...e.target, name: f.key, value: val },
                            });
                          } else {
                            handleChange(e);
                          }
                        }}
                      />
                      <ErrorMessage
                        message={
                          errors?.[f.key as keyof InterviewAssessmentTypes]
                        }
                      />
                    </>
                  )}
                </td>
              </tr>
            ))}
            <tr>
              <td className="td-label">
                Marital Status: <span className="text-danger">*</span>
              </td>
              <td className="d-flex gap-2 align-items-center">
                <select
                  name="maritalStatus"
                  className="form-control"
                  value={formData["maritalStatus"] ?? ""}
                  onChange={
                    (e) => handleFieldChange(e.target.name, e.target.value)
                    // setFormData((prev: any) => ({
                    //   ...prev,
                    //   maritalStatus: e.target.value,
                    // }))
                  }
                  style={{ width: "150px" }}
                >
                  <option value="">--Select--</option>
                  {maritalOptions.map((opt) => (
                    <option key={opt.key} value={opt.key}>
                      {opt.label}
                    </option>
                  ))}
                </select>
                {errors?.maritalStatus && (
                  <ErrorMessage message={errors?.maritalStatus} />
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PersonalDetails;
